'use client';

import useTopVoters from '@/application/epochs/useTopVoters';
import VoterHistoryTable from './VoterHistoryTable';
import { formatEther } from 'viem';
import { useChain } from '@/hooks/useChain';
import { absBigInt } from '@/utils/bigint';

const VoterHistoryTableContainer = () => {
  const chain = useChain();
  const { data: topVoters, status } = useTopVoters();

  const sorted = topVoters
    ?.map((a) => {
      const activeVotes = a.activeVotes.filter(
        (b) => b.type != 'NEW_COLLECTION_WAR',
      );
      return {
        ...a,
        activeVotes,
        votesCast: Number(
          formatEther(
            BigInt(
              activeVotes.reduce(
                (acc, cur) => acc + absBigInt(BigInt(cur.votesCast)),
                0n,
              ),
            ),
          ),
        ),
      };
    })
    .filter((a) => a.votesCast > 0)
    .sort((a, b) => b.votesCast - a.votesCast);

  return <VoterHistoryTable chain={chain} status={status} voters={sorted} />;
};

export default VoterHistoryTableContainer;
